import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Card, CardBody, Col, Container, Row, Form, Input, Label, FormFeedback, Spinner } from 'reactstrap';
import ParticlesAuth from '../ParticlesAuth';
import logoLight from "../../../assets/images/logo-light.png";

// Formik
import { useFormik } from 'formik';
import * as Yup from 'yup';

// AWS Amplify
import { updatePassword } from 'aws-amplify/auth';
import { toast } from 'react-toastify';
import BreadCrumb from '../../../Components/Common/BreadCrumb';

const ChangePassword = () => {

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    document.title = "Whistlemind Demo Engine | Update Password";

    const [passwordShow, setPasswordShow] = useState(false);
    const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);

    const validation = useFormik({
        initialValues: {
            old_password: "",
            new_password: "",
            confirm_password: "",
        },
        validationSchema: Yup.object({
            old_password: Yup.string().required("Old Password is required"),
            new_password: Yup.string()
                .min(8, 'Password must be at least 8 characters')
                .matches(/.*[a-z].*/, 'At least one lowercase letter')
                .matches(/.*[A-Z].*/, 'At least one uppercase letter')
                .matches(/.*[0-9].*/, 'At least one number')
                .matches(/.*[!@#$%^&*?].*/, 'At least one special character')
                .required("This field is required"),
            confirm_password: Yup.string()
                .oneOf([Yup.ref("new_password"), null], "Both passwords need to be the same")
                .required("Confirm Password is required"),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            try {
                // const user = await Auth.currentAuthenticatedUser();
                await updatePassword( {oldPassword:values.old_password, newPassword:values.new_password});
                toast.success("Password Updated Successfully");
                navigate('/dashboard'); // Add the route to navigate after a successful password change
            } catch (err) {
                toast.error(err.message);
            }
            setLoading(false);
        }
    });

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Change Password" pageTitle="" />
                <Row className="justify-content-center">
                    <Col md={8} lg={6} xl={5}>
                        <Card className="mt-4">
                            <CardBody className="p-4">
                                <div className="text-center mt-2">
                                    <h5 className="text-primary">Change password</h5>
                                    <p className="text-muted">Please Enter Old Password and New Password.</p>
                                </div>
                                <div className="p-2">
                                    <Form onSubmit={validation.handleSubmit}>
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="old_password">Old Password</Label>
                                            <div className="position-relative auth-pass-inputgroup">
                                                <Input
                                                    type={passwordShow ? "text" : "password"}
                                                    className={`form-control pe-5 password-input ${validation.touched.old_password && validation.errors.old_password ? 'is-invalid' : ''}`}
                                                    placeholder="Enter old password"
                                                    id="old_password"
                                                    name="old_password"
                                                    value={validation.values.old_password}
                                                    onBlur={validation.handleBlur}
                                                    onChange={validation.handleChange}
                                                />
                                                {validation.touched.old_password && validation.errors.old_password ? (
                                                    <FormFeedback type="invalid">{validation.errors.old_password}</FormFeedback>
                                                ) : null}
                                                <Button color="link" onClick={() => setPasswordShow(!passwordShow)} className="position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button">
                                                    <i className="ri-eye-fill align-middle"></i>
                                                </Button>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="new_password">New Password</Label>
                                            <div className="position-relative auth-pass-inputgroup mb-3">
                                                <Input
                                                    type={confirmPasswordShow ? "text" : "password"}
                                                    className={`form-control pe-5 password-input ${validation.touched.new_password && validation.errors.new_password ? 'is-invalid' : ''}`}
                                                    placeholder="Enter new password"
                                                    id="new_password"
                                                    name="new_password"
                                                    value={validation.values.new_password}
                                                    onBlur={validation.handleBlur}
                                                    onChange={validation.handleChange}
                                                />
                                                {validation.touched.new_password && validation.errors.new_password ? (
                                                    <FormFeedback type="invalid">{validation.errors.new_password}</FormFeedback>
                                                ) : null}
                                                <Button color="link" onClick={() => setConfirmPasswordShow(!confirmPasswordShow)} className="position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button">
                                                    <i className="ri-eye-fill align-middle"></i>
                                                </Button>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="confirm_password">Confirm Password</Label>
                                            <Input
                                                type={confirmPasswordShow ? "text" : "password"}
                                                className={`form-control pe-5 password-input ${validation.touched.confirm_password && validation.errors.confirm_password ? 'is-invalid' : ''}`}
                                                placeholder="Confirm new password"
                                                id="confirm_password"
                                                name="confirm_password"
                                                value={validation.values.confirm_password}
                                                onBlur={validation.handleBlur}
                                                onChange={validation.handleChange}
                                            />
                                            {validation.touched.confirm_password && validation.errors.confirm_password ? (
                                                <FormFeedback type="invalid">{validation.errors.confirm_password}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mt-4">
                                            <Button disabled={loading} color="success" className="w-100" type="submit">
                                                {loading ? <Spinner size="sm" className='me-2'>Loading...</Spinner> : "Change Password"}
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ChangePassword;
